import { reactive } from 'vue'

export const flashMessage = reactive({
  message: '',
  set(msg) {
    this.message = msg
    setTimeout(() => {
      this.message = ''
    }, 10000)
  }
})